import { america, callName, findMission } from '@/content/missions'
import { usePrefs } from './prefs'

const initialsOf = (words: string) =>
  words
    .split(/\s+/)
    .filter((word) => /^[A-Za-z]/.test(word) && !/^(and|of|the|for)$/.test(word))
    .map((word) => word[0].toUpperCase())
    .join('')

/**
 * The site's names for the active mission. The headline always uses the
 * mission's word ("Design for War."); the wordmark uses the word, the
 * initials or the agency's name ("War Design System", "DOW Design System",
 * "Department of War Design System"), or stays Mission Design System.
 */
export function useBrand() {
  const { prefs } = usePrefs()
  const mission = findMission(prefs.mission) ?? america
  const chosen = mission.id !== america.id
  const place = callName(mission)
  const brand = chosen ? prefs.brand : 'mds'
  const label = brand === 'word' ? place : brand === 'initials' ? mission.short : brand === 'name' ? mission.name : ''
  return {
    mission,
    place,
    name: brand === 'mds' ? 'Mission Design System' : `${label} Design System`,
    abbr: brand === 'mds' ? 'MDS' : brand === 'word' ? `${initialsOf(place)}DS` : `${mission.short} DS`,
  }
}
